"use client";

import { useEffect, useState } from "react";

export function useDelayElapsed(delayMs: number): boolean {
  const [didElapse, setDidElapse] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setDidElapse(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs]);

  return didElapse;
}
